import React from "react"

class App extends React.Component{
  constructor(props){
  super(props);
  this.state = {current: "Hit it!"}
  this.clickHandle = this.clickHandle.bind(this);
  this.keyHandle = this.keyHandle.bind(this);
  this.touchHandle = this.touchHandle.bind(this);
  this.removeClass = this.removeClass.bind(this);
  this.playSound = this.playSound.bind(this);
};

   
  componentDidMount(){
    document.addEventListener("keydown", this.keyHandle)
    document.addEventListener("transitionend", this.removeClass)
  };

  componentWillUnount(){
      document.removeEventListener("keydown", this.keyHandle)
      document.removeEventListener("transitionend", this.removeClass)
   };

  clickHandle(e){
    this.setState({current : e.target.getAttribute("name")});
    e.target.classList.add("active");
    const audioEl = e.target.childNodes[1];
    this.playSound(audioEl);
  };

  keyHandle(e){
    if(document.getElementById((e.key).toUpperCase())){
      document.getElementById(e.keyCode).classList.add("active")
      this.setState({ current : document.getElementById((e.key).toUpperCase()).getAttribute("name")}) 
      const audioEl = document.getElementById((e.key).toUpperCase());
      this.playSound(audioEl);
      }else{
          return
      }
  };

  touchHandle(e){
    this.setState({current : e.target.getAttribute("name")});
    e.target.classList.add("active");
    const audioEl = e.target.childNodes[1];
    this.playSound(audioEl);
  };

  removeClass(e){
    e.target.classList.remove("active")
  };

  playSound(audioEl){
    audioEl.currentTime = 0;
    audioEl.play();
  };

render(){ 
  const buttons = this.props.data.map(x => <div id={x.keyCode}  className={"drum-pad"} name={x.name} key={x.key}
    onClick={this.clickHandle} onTouchEnd={this.touchHandle}>
    {x.key}
    <audio id={x.key} key={x.key} src={x.sound} className="clip" name={x.name}></audio>
    </div>
  );
  return (
    <div id="drum-machine">
      <div id="pad-display-container">
        <div id="display"><h1>{this.state.current}</h1></div>
        {buttons}
      </div>
    </div>
  );
};
};

export default App;

